import React from 'react';
import classNames from 'classnames';
import classes from './style.module.scss';
import Icon from "~/app/common/Icon";
import {FilePayload} from "./../index"
import { useStoreState } from '~/store';
import { getAttachmentIconSrc, isChatImageExtension, getExtensionFromName } from '~/messages/attachmentUtils';

export interface PreviewProps {
    files: FilePayload[]
    removeFile: (index: number) => void
    editFile: (index: number) => void
}

export type PreviewComponent = React.FC<PreviewProps>

const isImageFile = (file: File): boolean => {
    if (file?.type?.startsWith('image/')) {
        return true;
    }
    const fileName = typeof file === 'string' ? file : file?.name;
    return isChatImageExtension(getExtensionFromName(fileName || ''));
};

const Preview: PreviewComponent = ({files, removeFile, editFile}) => {
    const netWorkStatus = useStoreState(state => state.app.offline.status);

    return (
        <div className={classes['file-preview-container']}>
            {files.map((file, index) => {
                const isImage = isImageFile(file.file);
                const fileName = typeof file.file === 'string' ? file.file : file.file?.name || 'document';
                const canEdit = isImage && !netWorkStatus;
                const fileKey = typeof file.file === 'string'
                    ? `${file.file}-${index}`
                    : `${file.file?.name}-${file.file?.size || ''}-${index}`;

                return (
                    <div className={classes['preview']} key={fileKey}>
                        {isImage ? (
                            <img src={file.previewUrl} alt="..." onClick={() => editFile(index)}/>
                        ) : (
                            <div className={classes['document-preview']} title={fileName}>
                                <img
                                    src={getAttachmentIconSrc(fileName)}
                                    alt=""
                                    className={classes['document-type-icon']}
                                />
                                <span className={classes['document-name']}>{fileName}</span>
                            </div>
                        )}
                        <div className={classNames(classes['actions'], { [classes['no-edit']]: !canEdit })} >
                            {canEdit && (
                                <Icon
                                    name={'edit'}
                                    className={`${classes['icon']} ${classes['edit']}`}
                                    onClick={(e) => { e.stopPropagation(); editFile(index); }}
                                />
                            )}
                            <Icon
                                name={'remove_circle'}
                                className={`${classes['icon']} ${classes['delete']}`}
                                onClick={(e) => { e.stopPropagation(); removeFile(index); }}
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    )
}

export default Preview
